<template>
    <div>
         <ThatsTable title="Items" ref="table" :multipleSelection="false" :endpoint="endpoint" :columns="columns" :newBtn="true" @open="openNewModal" @row-click="rowClick" :key="tableKey" :filterFormData="filterForm" @clearFilterForm="clearFilterForm">  
            <template #filter="{}">
                <ThatsInput tabindex="2" labelClass="col-sm-3" fieldClass="col-sm-9 pl-0" label="kerwords" vid="searchTerm" name="searchTerm" v-model="filterForm.searchTerm" size="sm" :disabled="false" :rules="''"/>
                <ThatsDatePicker :show_error="false" tabindex="1" labelClass="col-md-3" fieldClass="col-md-9 pl-0" label="Doc Date" placeholder="Date" vid="date" name="date" v-model="filterForm.date" :rules="''" size="sm" :disabled="false"/>                  
                <ThatsMultiSelect :show_error="true" :multiple="true" :clearable="true"  labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Location" v-model="filterForm.location" :reduce="label => label.value" :reduceLabel="'label'" :options="showroomLocation" :rules="''"></ThatsMultiSelect>
                <ThatsMultiSelect :show_error="true" :multiple="true" :clearable="true"  labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Approved By" v-model="filterForm.approvers" :reduce="label => label.value" :reduceLabel="'label'" :options="documentApprover" :rules="''"></ThatsMultiSelect>
                <ThatsMultiSelect :show_error="true" :multiple="true" :clearable="true"  labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Receiver" v-model="filterForm.receiver" :reduce="label => label.value" :reduceLabel="'label'" :options="documentReceiver" :rules="''"></ThatsMultiSelect>
                <ThatsMultiSelect :show_error="true" :multiple="true" :clearable="true"  labelClass="col-md-3" fieldClass="col-md-9  pl-0" label="Status" v-model="filterForm.status" :reduce="label => label.value" :reduceLabel="'label'" :options="docStatus" :rules="''"></ThatsMultiSelect>

     
            </template> 

            <template #custom-right-culumns="{}">

            <el-table-column :sortable="false" :prop="'id'" label="SAP No." width="200">
                    <template slot-scope="scope">
                        <template v-if="scope.row.show_document_number">
                            <template v-if="scope.row.document_number != null && ['approved'].includes(scope.row.status)">
                                <mdb-badge class="custom-badge z-depth-0" pill :color="statusArrayColor['approved']"><i :class="statusArrayIcon['approved']"></i> {{ scope.row.document_number}}</mdb-badge>

                                <span class="copy" @click="copyValue(scope.row.document_number)" :ref="`copy-data-${scope.row.id}`">Copy</span> 
                            </template>
                            <template v-else>
                                
                                <mdb-badge class="custom-badge z-depth-0" pill :color="statusArrayColor['for-approval']"><i :class="statusArrayIcon['for-approval']"></i> Pending for Syncing</mdb-badge>
                            </template>
                        </template>
                        <template v-else>
                            -
                        </template>
                    </template>
                </el-table-column>

                <el-table-column :sortable="false" :prop="'id'" label="REQUESTED BY" width="200">
                    <template slot-scope="scope">
                        {{ scope.row.requested_by.name }}
                    </template>
                </el-table-column>


                <el-table-column :sortable="false" :prop="'id'" label="Approver" >
                    <template slot-scope="scope">
                        {{ scope.row.approver }}
                      
                    </template>
                </el-table-column>
                <el-table-column :sortable="false" :prop="'id'" label="Approved by" width="250">
                    <template slot-scope="scope">
                        {{ scope.row.approved_by.name }}
                    </template>
                </el-table-column>

                <el-table-column :sortable="false" :prop="'id'" label="Approved Date" width="200">
                    <template slot-scope="scope">
                        {{ scope.row.approved_by.date }}
                    </template>
                </el-table-column>
                <el-table-column :sortable="false" :prop="'id'" label="Status" width="150">
                    <template slot-scope="scope">
                        
                        <mdb-badge class="custom-badge z-depth-0" pill :color="statusArrayColor[scope.row.status]"><i :class="statusArrayIcon[scope.row.status]"></i> {{ scope.row.status_text}}</mdb-badge>
                        
                    </template>
                </el-table-column>
               <!--  <el-table-column :sortable="false" width="120" :prop="'id'" label="PRINT">
                        <template slot-scope="scope">
                            <el-button @click="fnPrintDoc('/inventory-transfer-request/print/'+scope.row.series)" size="small" class="text-info"><i class="el-icon-printer text-info cursor-pointer"></i> PRINT</el-button>
                        </template>
                    </el-table-column> -->

            </template>

        </ThatsTable>
        <InventoryTransferRequestForm2 ref="bringToShowroomForm" @success="refreshTable"></InventoryTransferRequestForm2>
    </div>
</template>
<script>
/* eslint-disable no-unused-vars */

import { mapGetters, mapMutations,mapActions } from 'vuex';
import ThatsTable from './Table'
import {mdbBadge} from 'mdbvue'
import { ThatsDatePicker, ThatsMultiSelect, ThatsInput} from '../../components/thats/Thats'
import { MessageBox , Message} from 'element-ui'

import { Loading } from 'element-ui';
// import InventoryTransferRequestForm from './InventoryTransferRequestForm.vue'
import InventoryTransferRequestForm2 from './InventoryTransferRequestForm2.vue'

export default {
        components:{
        ThatsTable,
        mdbBadge,
        ThatsDatePicker,
        ThatsMultiSelect,
       InventoryTransferRequestForm2,
        ThatsInput
    },
    inject : ['showroomsProvider'],
    provide(){
        return {
            btsApproverProvider : () => this.approverData,
            btsReceiverProvider : () => this.receiverData,
        }
    },
    data(){
        return {
            endpoint : 'inventory-transfer-request',
            approver : [],
            receiver : [],
            tableKey : 0,
            filterForm : {
                date : '',
                searchTerm : null,
                location : null,
                approvers : null,
                receiver : null,
                status : null,
            },
            docStatus : [
                {value : 'for-approval', label : 'For Approval'},
                {value : 'rejected', label : 'Rejected'},
                {value : 'approved', label : 'Approved'},
            ]
        }
    },


    created(){
      //  this.exportTableOptions.tableWidth = `${window.innerWidth - 3}px`

      /* console.log("this.$route")
      console.log(this.$route) */
      const self = this;
        this.getApprover().then((res) =>  this.approver = res);
        this.getReceiver().then((res) => {
            if(res.length > 0){
                self.receiver = res.filter((user)=>{
                    return ['warehouse','delivery-team','showroom-manager','general-manager','interior-designers','administrator','back-office'].some(item => user.role_slugs.includes(item));
                })
            }
        });
    },

    mounted(){
        const self = this;

        // console.log("onmounted")
        this.$eventBus.$on('reloadTable',function(){
            self.tableKey++
            self.setFilters();
        })
    },
    methods: {
       ...mapActions('BringToShowroomModule',['getApprover']),
       ...mapActions('InventoryTransferRequestModule',['getRecord','getReceiver']),
       ...mapMutations('InventoryTransferRequestModule',['setFormStatusUpdate','setFormStatusCreate','setEmptyForm','setFilters']),

        rowClick(row){
            const self = this;
            const loading = Loading.service({
                fullscreen: true ,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.7)'
                }); 
                self.setFormStatusUpdate(); 
            this.getRecord(row).then(() => {
                loading.close();
                
                self.$refs.bringToShowroomForm.openDialog();
            })
        },
        openNewModal(){
            this.setFormStatusCreate();
            this.setEmptyForm();
           this.$refs.bringToShowroomForm.openDialog();
        },
        refreshTable(){
            // //alert(1)
            this.tableKey++
            this.$refs.table.refreshTable()
           
        },

        fnPrintDoc(url){
        // this.printUrl = url
          const windowHeight =  window.innerHeight;
          const innerWidth =  window.innerWidth;

         var strWindowFeatures = "location=yes,height="+windowHeight+",width="+innerWidth+",scrollbars=yes,status=yes";
        const win = window.open(`${url}`, "_blank", strWindowFeatures);
        win.document.title = 'Print';
        win.print()

        // this.$refs.printWindow.openDialog();
      },

      clearFilterForm(){
        this.filterForm = JSON.parse(JSON.stringify(
            {
                date : '',
                searchTerm : null,
                location : null,
                approvers : null,
                receiver : null,
                status : null,
            }
        ))
      },
      copyValue(value){
            var dummy = document.createElement("textarea");
              document.body.appendChild(dummy);
              dummy.setAttribute("id", "dummy_id");
              document.getElementById("dummy_id").value=value;
              dummy.select();
              document.execCommand("copy");
              document.body.removeChild(dummy);

              
                Message.success({
                message: "Copied!"
                });

       },
    },
    computed: {
        ...mapGetters('InventoryTransferRequestModule',['getLoading', 'columns','initialForm']),
        approverData : function(){
            return this.approver
        },
        receiverData : function(){
            return this.receiver
        },

        statusArrayText : function(){
        
            return {'draft' : 'Draft','for-approval' : 'For Approval','approved': 'Approved','rejected' :'Rejected','save' : 'Saved'};
        },
        statusArrayColor : function(){
        
            return {'draft' : 'badge-light','for-approval' : 'warning','save' : 'warning','approved': 'success','rejected' : 'danger'};
        },
        statusArrayIcon : function(){
        
            return {'draft' : 'el-icon-more','for-approval' : 'el-icon-circle-check','save' : 'el-icon-circle-check','approved': 'el-icon-success','rejected' : 'el-icon-remove'};
        },

        showroomLocation : function(){

            const showroom = this.showroomsProvider();

            return showroom.map((item) => {
                return {...item, label : `${item.prefix} - ${item.label}`,prefix : item.prefix}
            },[])
        },
        documentApprover : function(){

            return this.approver.map((item) => {
                return {...item, label : `${item.name}`,value : item.id}
            },[])
        },
        documentReceiver : function(){
            return this.receiver.filter((user) => {
                return ['warehouse','delivery-team','showroom-manager','interior-designers','back-office','administrator'].some(item => user.role_slugs.includes(item)) 
            },[]).map((item) => {
                return {...item, label : `${item.name}`,value : item.id}
                },[])
        },
    },
}


</script>